import { registerBlockType } from '@wordpress/blocks';
import { SelectControl, TextControl, RangeControl, PanelBody, PanelColorSettings } from '@wordpress/components';
import { InspectorControls,
    __experimentalColorGradientSettingsDropdown as ColorGradientSettingsDropdown,
    __experimentalUseMultipleOriginColorsAndGradients as useMultipleOriginColorsAndGradients } 
from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

registerBlockType('custom-link-button/block', {
    title: 'Link Custom',
    icon: 'admin-links',
    category: 'layout',
    attributes: {
        pages: {
            type: 'array',
            default: [],
        },
        pageLink: {
            type: 'string',
            default: ''
        },
        pageName: {
            type: 'string',
            default: '',
        },
        text: {
            type: 'string',
            default: 'Scopri di più'
        },
        linkColor: {
            type: 'string',
            default: ''
        },
        fontSize: {
            type: 'number',
            default: 16 // Imposta una dimensione di font predefinita.
        }
    },
    supports : {
        color: {
            text : true,
        }
    }, 
    edit: ({ attributes, setAttributes }) => {
    
        const { pages, pageLink, pageName, text, linkColor, fontSize } = attributes;

        const fetchPages = () => {
            apiFetch({path: `/wp/v2/pages`}).then(res => {
                setAttributes({pages: res});
            });
        };

        const colorGradientSettings = useMultipleOriginColorsAndGradients();

        useEffect(() => {
            fetchPages();
        }, []);

        const pagesOption = [
            {label: 'Seleziona una pagina', value: ''},
            ...pages.map(page => ({label: page.title.rendered, value: page.title.rendered})
            )
        ];

        return (
            <>
            <InspectorControls>
                <PanelBody title='Campi link'>
                    <SelectControl 
                        label='Pagina collegata'
                        options={pagesOption}
                        value={pageName}
                        onChange={pName => {
                            const selectedPage = pages.filter(page => page.title.rendered === pName)[0];
                            setAttributes({
                                pageName: pName,
                                pageLink: selectedPage.link
                            });
                        }}
                    />
                    {pageName === '' && (<>
                        <p style={{ fontSize: '12px', color: '#666', fontStyle: 'italic'}}>
                            Nel caso in cui il link non sia tra le pagine del sito, inserisci l'URL qui sotto.
                        </p>
                        <TextControl 
                            label='Link esterno'
                            type='string'
                            value={pageLink}
                            onChange={link => {
                                setAttributes({pageLink: link});
                            }}
                        />
                        </>
                    )}
                    <TextControl 
                        label='Testo del link'
                        type='string'
                        value={text}
                        onChange={newText => {
                            setAttributes({text: newText});
                        }}
                    />
                    <RangeControl
                        label="Dimensione del carattere (px)"
                        value={fontSize}
                        onChange={(size) => setAttributes({ fontSize: size })}
                        min={10}
                        max={50}
                    />
                </PanelBody>
                <ColorGradientSettingsDropdown
                    settings={[{
                        label: 'Colore link',
                        colorValue: linkColor,
                        onColorChange: ( color ) => setAttributes( { linkColor: color } ),
                    }]}
                    {...colorGradientSettings}
                />
            </InspectorControls>
            <a href={pageLink} style={{ fontSize: `${fontSize}px`, color: linkColor }}>{text}</a>
            </>
        );
    },
    save: ({attributes}) => {
        const { pageLink, text, linkColor, fontSize } = attributes;
        return <a className="custom-link" href={pageLink} style={{ fontSize: `${fontSize}px`}}>{text}</a>;
    },
});